import axios from 'axios'

import { handleUnauthorizedResponse } from '../../utils/unauthorizedSession'

const BASE_URL = import.meta.env.VITE_API_BASE_URL

export const getTimelineActionAllData = async (
  language = 'ptBR',
  page = 1,
  size = 4
) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))

  const config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }

  return await axios
    .get(
      `${BASE_URL}timeline-actions-all-data/${language}?page=${page}&pageSize=${size}`,
      config
    )
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      handleUnauthorizedResponse(error)
      console.log('error getTimelineActionAllData', error.response?.data)
      return error
    })
}

export const getTimelineActionAllDataList = async (language) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))

  const config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }

  return await axios
    .get(`${BASE_URL}timeline-actions-all-data/${language}`, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      handleUnauthorizedResponse(error)
      console.log('error getTimelineActionAllData', error.response?.data)
      return error
    })
}

export const getAllTimelineCountPublication = async () => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))

  const config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }

  return await axios
    .get(`${BASE_URL}timeline-publication/count`, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      handleUnauthorizedResponse(error)
      console.log('error getAllTimelineCountPublication', error.response?.data)
      return error
    })
}
